import { Dropdown } from './dropdown/select-dropdown';
import { Menu } from './menu/select-menu';
export const Select = () => null;
Select.Menu = Menu;
Select.Dropdown = Dropdown;
//# sourceMappingURL=select.js.map